<template>
  <div class="jobs">
    <div class="head row align-center column-s">
      <h1>JOBS</h1>
      &nbsp;&nbsp;&nbsp;
      <Button :layout="showForm ? 'red-go' : 'green-go'" title="NOVO JOB" @click="showForm = !showForm;
      form = { ...initForm }">{{ showForm ? "x" : "+" }}</Button>
      <transition name="slide">
        <div v-if="showForm" class="new grid-11">
          <JobForm :job="form" />
        </div>
      </transition>
    </div>
    <div class="filters row column-s align-center">
      <div class="meus column">
        <label>{{ turnkey.on ? 'Meus Jobs' : 'Todos' }}</label>
        <Turnkey :data="turnkey" />
      </div>
      <div class="column grid-12-s">
        <label>Data</label>
        <input type="date" class="date" v-model="filters.data_unica" />
      </div>
      <div class="grid-2 grid-12-s column">
        <label for="etapa">Etapa</label>
        <select class="input" v-model="filters.nucleo">
          <option value=" ">Selecione</option>
          <option value="associacao">Associação</option>
          <option value="abertura">Abertura</option>
          <option value="acompanhamento">Acompanhamento</option>
        </select>
      </div>
      <div class="grid-2 grid-12-s column">
        <label for="tipoAtendimento">Tipo atendimento</label>
        <select class="input" v-model="filters.tipo">
          <option value=" ">Selecione</option>
          <option value="atendimento">Avulso</option>
          <option value="alocacao">Alocação</option>
        </select>
      </div>
      <div class="column grid-1 grid-12-s" style="margin-right: 30px;">
        <label>ID</label>
        <input type="text" v-model="ID" @keyup.enter="load" placeholder="ID" />
      </div>
      <Button layout="green-go" @click="load" :loader="loader"><i class="fa fa-search" /> LISTAR</Button>
    </div>
    <div v-if="loader" class="column align-center justify-center">
      <Loader layout="small" />
    </div>
    <div v-if="!loader && list.length" class="list">
      <div class="container">
        <div class="head row justify-space">
          <div class="grid-1">Job</div>
          <div class="grid-2">GD</div>
          <div class="grid-1">Candidatos</div>
          <div class="grid-2">Tipo Serviço</div>
          <div class="grid-2">Status</div>
          <div class="grid-2">Supporter</div>
          <div class="grid-2">Local</div>
          <div class="grid-2">Agendamento</div>
          <div class="grid-2">Encerramento</div>
          <div class="grid-1"></div>
        </div>
        <div class="content">
          <div v-for="(item, i) of list" :key="'item' + i" :class="item.sla_vencido == 'sim' && 'red'">
            <div class="line row justify-space align-center" @click.stop="toggle(i)">
              <div class="grid-1">{{ item.id }}</div>
              <div class="grid-2">{{ item.nome_gestor }}</div>
              <div class="grid-1">{{ item.total_candidatos }}</div>
              <div class="grid-2">{{ item.tipo_servico }}</div>
              <div class="grid-2">{{ item.status.replace("Doutor", "Supporter") }}</div>
              <div class="grid-2">{{ item.nome_doutor }}</div>
              <div class="grid-2">{{ item.estado }}/{{ item.cidade }}</div>
              <div class="grid-2">{{ item.dh_agendamento_cliente | datetime }}</div>
              <div class="grid-2">{{ item.sla_encerramento | datetime }}</div>
              <div class="grid-1"><a :href="'/funcionario/job/' + item.id" target="_blank"><Button
                    layout="green-go">Job</Button></a></div>
            </div>
            <div v-if="item.show" class="edit row wrap column-s">
              <Job :id="`${item.id}`" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal :modal="modal">
      <div class="historic" v-if="modal.mod == 'historic'">
        <div class="title row">
          <div class="grid-1">ID</div>
          <div class="grid-8">Histórico</div>
          <div class="grid-3">Criado</div>
        </div>
        <div class="line row align-center" v-for="item of historic.list" :key="item.id">
          <div class="grid-1">{{ item.id }}</div>
          <div class="grid-8">{{ item.historico }}</div>
          <div class="grid-3" style="min-width: 160px"><b>{{ item.criado_em | date }}</b> por {{ item.nome_criado_por }}
          </div>
        </div>
      </div>
      <div class="historic files" v-if="modal.mod == 'files'">
        <div class="title row">
          <div class="grid-3">Enviado</div>
          <div class="grid-6">Arquivo</div>
          <div class="grid-3">Data Validação</div>
        </div>
        <div class="line row align-center" v-for="item of files.list" :key="item.criado_em">
          <div class="grid-3">{{ item.criado_em | date }}</div>

          <div class="grid-6"><a :href="`/portal/arquivo/${item.id}/doutor/${item.id_doutor}`" target="_blank">{{
            item.descricao
              }}</a></div>
          <div class="grid-3">{{ item.dh_validacao | date }}
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import Button from "@/components/Button.vue";
import Loader from "@/components/Loader.vue";
import Modal from "@/components/Modal.vue";
import Turnkey from "@/components/Turnkey.vue";
import Job from "@/views/admin/components/Job.vue";
import JobForm from "@/views/admin/components/JobForm.vue";

export default {
  name: "Jobs",
  components: {
    Button,
    Loader,
    Modal,
    Turnkey,
    JobForm,
    Job
  },
  data() {
    return {
      ID: "",
      loader: false,
      showForm: false,
      historic: {
        mod: 'historic',
        title: "Histórico Supporter",
        show: true,
        callback: () => this.historic.show = true,
        list: []
      },
      files: {
        mod: 'files',
        title: "Arquivos do Supporter",
        show: true,
        callback: () => this.files.show = true,
        list: []
      },
      modal: {},
      list: [],
      search: "",
      form: { ...this.initForm },
      turnkey: {
        show: true,
        on: false,
        toggle: () => {
          this.turnkey.on = !this.turnkey.on;
          this.filters.meus = this.turnkey.on;
        },
      },
      filters: {
        meus: false,
        data_unica: "",
        codigo_chamado_cliente: "",
        nucleo: " ",
        tipo: " "
      },
      initForm: {
        send: this.create,
        urgencia_atendimento: "",
        dh_agendamento_cliente: "",
        cep: "",
        bairro: "",
        celular_contato: "",
        cidade: "",
        codigo_chamado_cliente: "",
        codigo_duplicado: false,
        codigo_venda: null,
        complemento: "",
        email_contato: "",
        estado: "",
        forma_atendimento: null,
        id_cliente: 1,
        id_projeto: null,
        latitude: null,
        longitude: null,
        logradouro: "",
        motivo_codigo_duplicado: "",
        nome_contato: null,
        nome_local_atendimento: "",
        numero: "",
        problema: "",
        dado_sensivel: "",
      }
    };
  },
  methods: {
    ...mapActions("admin", ["SUPPORTERS_FILES", "JOBS_LIST", "JOB_GET", "JOB_CREATE", "SUPPORTERS_DEL", "SUPPORTERS_UPDATE", "SUPPORTERS_UPDATE_STATUS"]),
    ...mapActions("client", ["CREATE_JOB"]),
    ...mapMutations("general", ["SET_STATUS"]),
    async load() {
      if (this.ID.length) {
        window.open(`/funcionario/job/${this.ID.replace('-', '').replace(' ', '').replace('.', '')}`, '_blank')
        this.ID = ""
      } else {
        this.loader = true
        let filter = {}
        for (let f in this.filters)
          if (this.filters[f] != "" && this.filters[f] != " ") filter[f] = this.filters[f]
        filter.meus = this.filters.meus
        await this.JOBS_LIST(filter).then(({ data }) => this.list = data || [])
        this.loader = false
      }
    },
    getFiles(ID) {
      this.SUPPORTERS_FILES({ id_doutor: ID, ignora_nota_fiscal: true }).then(({ data }) => {
        if (data.length) {
          this.files = { ...this.files, list: data } || [];
          this.modal = { ...this.files }
        }
      })
    },
    clearForm(form) {
      if (form.urgencia_atendimento == 'agendado')
        form.dh_agendamento_cliente = `${form.dh_agendamento_cliente_data} ${form.dh_agendamento_cliente_hora}`
      delete form.dh_agendamento_cliente_data
      delete form.dh_agendamento_cliente_hora
      form.cep = form.cep.replace('-', '').replace('.', '')
      form.celular_contato = form.celular_contato.replace("(", "")
        .replace(")", "")
        .replace("-", "")
        .replace(/ /g, "");
      return form
    },
    async create(f) {
      var form = this.clearForm({ ...f })
      if (!form.cep || !form.logradouro || !form.bairro || !form.cidade || !form.estado)
        return;

      this.$gmapApiPromiseLazy()
        .then(() => {
          // eslint-disable-next-line no-undef
          var geocoder = new google.maps.Geocoder();
          var endereco = `${form.logradouro} ${form.numero} ${form.bairro} ${form.cidade} ${form.estado}`;
          var self = this;

          geocoder.geocode({ address: endereco }, function (results, status) {
            // eslint-disable-next-line no-undef
            if (status == google.maps.GeocoderStatus.OK) {
              form.latitude = results[0].geometry.location.lat();
              form.longitude = results[0].geometry.location.lng();

              self.CREATE_JOB(form).then((r) => {
                if (r && r.status == 201) {
                  self.showForm = false;
                  if (r.data.id) window.open(`/funcionario/job/${r.data.id}`, '_blank')
                }
              });
            } else {
              self.SET_STATUS({
                text: "Endereço não encontrado, não é possível criar o Job.",
                color: "red",
              });
            }
          });
        })
        .catch((e) => {
          console.error("[Job] Falha no Google Maps ao gravar o Job (admin/Jobs):", e);
          alert("Você parece estar sem conexão.");
        });
      return
    },
    del(item) {
      return this.SUPPORTERS_DEL(item.id).then(() => this.load());
    },
    async update(item) {
      item = await this.clearForm(item)
      this.SUPPORTERS_UPDATE({ ...item, params: item.id }).then(({ status }) => (status == 200 || status == 201) && this.load());
    },
    async update_status(ID) {
      this.SUPPORTERS_UPDATE_STATUS(ID).then(({ status }) => (status == 200 || status == 201) && this.load());
    },
    async toggle(index) {
      this.list[index].show = !this.list[index].show;
      this.list = [...this.list];
    },
    async openContract(supporter) {
      if (supporter.dh_aceite_termo) {
        window.open('/TermoSupporter.html', '_blank')
      } else alert('Supporter ainda não aceitou os termos')
    },
    async sla(r) {
      let f = {}
      if (r == 'novos') f = { meus: false, status_simplificado: "aberto", sla_vencido: "nao" }
      if (r == 'aberto') f = { meus: false, status_simplificado: "aberto", sla_vencido: "sim" }
      if (r == 'andamento') f = { meus: true, status_simplificado: "andamento", sla_vencido: "nao" }
      if (r == 'sla') f = { meus: true, status_simplificado: "andamento", sla_vencido: "sim" }
      this.loader = true
      await this.JOBS_LIST(f).then(({ data }) => this.list = data || [])
      this.loader = false
    }
  },
  watch: {
    $route: {
      handler: function (n) {
        if (n.params.id)
          this.sla(n.params.id);
      },
      deep: true
    }
  },
  mounted() {
    this.$parent.$children[0].changeMenu("jobs");
    if (this.$route.params.id) this.sla(this.$route.params.id)
  }
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.jobs
  @include page
  @media (min-width: $small)
    margin-top: -30px
  .new
    margin-bottom: 30px
  .filters
    margin-top: 12px
    @media (max-width: $small)
      padding: 0 20px
    .column
      margin-bottom: 30px   
    .turnkey
      margin-top: 8px
    .date
      width: 132px
      margin-right: 16px
      @media (max-width: $small)
        width: 94%
        margin-bottom: 0  
    button
      margin-bottom: 10px
  .loader
    margin-top: 100px
  .meus
    min-width: 86px 
  .list
    overflow: auto
    font-size: 15px
    @media (max-width: $small)
      margin: 23px 6px
    .content
      border-radius: 23px
      max-height: 790px
      background: #f9f9f9
      border-radius: 0
      border-top-left-radius: 20px
      border-top-right-radius: 20px
      overflow-x: auto
      .red .line
        color: $red
      .line
        height: 40px
        border-top: 2px solid #fff
        border-radius: 0
        word-break: break-all
        &:hover
          background: $purple
          color: white
          border-radius: 0
          & + .edit .job
            border-radius: 0
          button
            color: $purple
            background: white
      .edit
        padding: 0
        background: white
    .container
      min-width: 1200px
      border-radius: 23px
      .head
        background: white
    .controls
      color: $purple
      font-size: 19px
    .line:hover
      .controls
        color: white
  .historic
    max-height: 400px
  
</style>
